/*
 * AdvaHealth Solutions Pty. Ltd. ("AHS") CONFIDENTIAL
 * Copyright (c) 2022 AdvaHealth Solutions Pty. Ltd. All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of AHS. The intellectual and technical concepts contained
 * herein are proprietary to AHS and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from AHS.  Access to the source code contained herein is hereby forbidden to anyone except current AHS employees, managers or contractors who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of AHS. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */

import React, { FC, useMemo } from "react";
import Logo1x from "../../assets/images/new_brand/main/logo-advapacs-main-1x.png";
import Logo2x from "../../assets/images/new_brand/main/logo-advapacs-main-2x.png";
import Logo3x from "../../assets/images/new_brand/main/logo-advapacs-main-3x.png";
// DARK LOGO
import LogoDark from "../../assets/images/new_brand/main/logo-adva-dark.svg";

type LoaderProps = {
  text?: string;
  isDark?: boolean;
};

export const Loader: FC<LoaderProps> = ({ isDark = false }) => {
  const styles = useMemo(() => {
    if (isDark) {
      return {
        width: 210,
        height: 110,
      };
    }

    return {};
  }, [isDark]);

  return (
    <div className={`loader-holder ${isDark ? "dark" : ""}`}>
      <div className="logo-wrapper animated pulse infinite slow">
        <img
          src={isDark ? LogoDark : Logo1x}
          srcSet={isDark ? LogoDark : `${Logo2x} 2x, ${Logo3x} 3x`}
          className="mb-3 mt-1"
          width="100%"
          style={styles}
          alt="logo"
        />
      </div>
    </div>
  );
};
